import React, { useState } from 'react';
import { Modal, Form, Input, Button, notification, Spin } from 'antd';
import { useDispatch } from 'react-redux';
import { deleteCard as deleteCardAction } from '../../store/actions/cards';
import CardFront from './front';
import { ExclamationIcon, TrashIcon } from '@heroicons/react/outline';

const DeleteCard = ({ card }) => {
  const dispatch = useDispatch();
  const [modalDelete, showModalDelete] = useState(false);

  const [confirmDelete, setConfirmDelete] = useState(false);
  const [loading, setLoading] = useState(false);

  const checkCodeConfirm = (rule, value, callback) => {
    if (card.code !== value) {
      setConfirmDelete(false);
      return callback('El código ingresado no coincide.');
    }

    setConfirmDelete(true);
  };

  const deleteCard = async () => {
    try {
      setLoading(true);
      const res = await dispatch(deleteCardAction(card.id));

      notification.open({ type: 'success', message: res.message, placement: 'bottomRight' });

      showModalDelete(false);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="flex gap-1"
        onClick={() =>
          setTimeout(() => {
            showModalDelete(true);
          }, 200)
        }
      >
        <TrashIcon width={16} /> Eliminar
      </div>
      <Modal
        visible={modalDelete}
        title={<h1 className="text-lg">Eliminar tarjeta {card.code}</h1>}
        footer={null}
        bodyStyle={{ padding: '10px 20px' }}
        onCancel={() => showModalDelete(false)}
      >
        <div className="py-4 px-2 bg-red-400 rounded-md mt-2 text-white font-medium">
          <ExclamationIcon width={24} className="inline mb-1" />
          <span> Advertencnia: Esta acción no se puede revertir.</span>
        </div>

        <div className="scale-90 transform flex justify-center my-2">
          <CardFront card={card} readonly />
        </div>

        <div className="text-xs text-black text-opacity-50 mb-1">
          Ingrese el código de la tarjeta para confirmar la eliminación.
        </div>
        <Form>
          <Form.Item
            name="code"
            rules={[{ required: true, validator: checkCodeConfirm }]}
          >
            <Input placeholder={`${card.code}`} size="large" />
          </Form.Item>
          <Form.Item className="">
            <div className="flex justify-end">
              <Button
                size="large"
                onClick={() => deleteCard()}
                disabled={!confirmDelete || loading}
                className="bg-red-600 text-white font-medium rounded-md hover:bg-red-700 hover:text-white focus:bg-red-500 focus:text-white"
              >
                Eliminar {loading && <Spin size="small" className="ml-2" />}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default DeleteCard;
